import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { validateRegisterOTP } from '../../operations/form-validation/formValidation';
import * as actions from "../../actions/ordersAction";
import Input from "sushiweb/InputTypes/Input";
import Check from "sushiweb/Icons/all/Check";
import * as symbols from '../../operations/symbols';
import OTPFieldComponent from './../core/OTPFieldComponent/OTPFieldComponent';

class DeliveryOTPComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      otp: {
        fields: {
          otp: '',
          orderId: ''
        },
        errors: {
          otp: null
        }
      },
      validations: {
        otp: null,
      },
      allValidated: false,
      validationFailed: false,
      resetSetTimeout: false
    }
  }

  handleChange(type, field, value) {
    this.setState(prevState => ({
      [type]: {
        errors: {
          ...prevState[type].errors,
        },

        fields: {
          ...prevState[type].fields,
          [field]: value
        }
      }
    }), () => {
      this.validateThisField(type, field, value);
    })
  }

  beginValidation(type, field, value) {
    this.setState(prevState => ({
      validations: {
        ...prevState.validations,
        [field]: true
      }
    }), () => {
      this.validateThisField(type, field, value);
    })
  }

  validateThisField(type, field, value) {
    var errList = validateRegisterOTP(this.state[type]);
    var err = errList[field];
    this.setState(prevState => ({
      [type]: {
        ...prevState[type],
        errors: {
          ...prevState[type].errors,
          [field]: err
        }
      },
      allValidated: errList.isValidated
    }))
  }

  resendOtp(onCall) {
    let otpFields = {};
    if (onCall) {
      otpFields.voice = true;
    }
    otpFields.phoneNumber = this.props.phoneNumber
    this.setState({ resetSetTimeout: true });
    setTimeout(() => {
      this.setState({ resetSetTimeout: false });
    }, 15000);
    otpFields.orderId = parseInt(this.props.match.params.id)
    this.props.actions.resendDeliveryOtp(otpFields)
  }

  onSubmitOTP(e) {
    e.preventDefault();
    let otpValidatedData = validateRegisterOTP(this.state.otp);
    if (!otpValidatedData.isValidated) {
      this.setState(prevState => ({
        otp: {
          ...prevState.otp,
          errors: otpValidatedData
        }
      }))
    } else {
      this.setState(prevState => ({
        otp: {
          ...prevState.otp,
          errors: {}
        }
      }), () => {
        let otpFields = this.state.otp.fields;
        otpFields.orderId = parseInt(this.props.match.params.id)
        this.props.actions.verifyDeliveryOtp(otpFields);
      })

    }
  }

  componentDidUpdate(prevProps) {
    const { verifyOtpStatus } = this.props;
    if (verifyOtpStatus !== prevProps.verifyOtpStatus && verifyOtpStatus === symbols.STATUS_DONE) {
      this.props.history.replace('/success')
    }
    if (verifyOtpStatus !== prevProps.verifyOtpStatus && verifyOtpStatus === symbols.STATUS_FAIL) {
      this.setState({ validationFailed: true })
    }
  }

  render() {
    const { resendDeliveryOtpStatus } = this.props;
    return (
      <div className="mt-2 fs-14 global-form">
        {
          this.props.hasSentOTP &&
          <div>
            We have sent 6 digit otp to {this.props.phoneNumber}
          </div>
        }
        <form onSubmit={(e) => this.onSubmitOTP(e)}>
          <div className="input-field-wrap mt-4">
            {/* <Input
              label="Enter OTP"
              type="text"
              name="otp"
              otp={'otp1'}
              icon={this.state.validations.otp ? this.state.otp.errors.otp ? null : <Check/> : null}
              iconColor="green"
              value={this.state.otp.fields.otp}
              onBlur={(e) => this.beginValidation('otp', 'otp', e)}
              errorMsg={this.state.validations.otp ? this.state.otp.errors.otp : null}
              onChange={(e) => this.handleChange('otp', 'otp', e)}
            /> */}
            <OTPFieldComponent 
              digits={6} 
              onChange={(value) => this.handleChange('otp', 'otp', value)} 
              validateOTP={(value) => this.beginValidation('otp', 'otp', value)}
              errorMsg={this.state.validations.otp ? this.state.otp.errors.otp : null}
            />
            {
              this.state.validationFailed &&
              <span> Wrong OTP</span>
            }
          </div>
          <div className="btn-wrapper">
            {
              this.props.verifyOtpStatus === symbols.STATUS_BEGIN ?
                <button className= "btn btn-disabled">
                  { "Verifying..."}
                </button>
                :
                <button type="submit" className={this.state.allValidated ? "btn btn-green" : "btn btn-disabled"}>
                  { "Verify OTP"}
                </button>
            }
          </div>
          <React.Fragment>
            {
              this.props.hasSentOTP &&
              <div className="btn-wrapper mt-4">
                Didn't receive OTP?
                <br/>
                {
                  resendDeliveryOtpStatus === symbols.STATUS_BEGIN ? 
                  <span className="green-link">Sending...</span> :
                  <React.Fragment>
                  <span className={this.state.resetSetTimeout ? `green-link disabled` : `green-link pointer` } onClick={() => this.resendOtp()}>Resend OTP</span>
                  
                  </React.Fragment>
                }
              </div>
            }
          </React.Fragment>
          
          <div className="mt-7">
            <div className="light-line"/>
            Merchant not available?
            <br/>
            <div className="green-link mt-1" onClick={this.props.backToPhoneSelect}>Change Number</div>
          </div>
          {
            this.props.errors && this.props.errors.error ?
              <div className="error mt-1">{this.props.errors.error.message}</div> : null
          }
        </form>
      </div>
    )
  }
}


export default withRouter(connect(
  state => ({
    verifyOtpError: state.statuses.verifyDeliveryOtp.error,
    verifyOtpStatus: state.statuses.verifyDeliveryOtp.status,
    resendDeliveryOtpStatus: state.statuses.resendDeliveryOtp.status,
    resendDeliveryOtpError: state.statuses.resendDeliveryOtp.error
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(DeliveryOTPComponent));
